(function () {
   'use strict';

   module.exports = AssetCoreVideo;
   var AssetCoreMedia = require('./media.js');
   var helper = require('../helpers/generic.js');
   var logger = new (require('../helpers/logger.js'))("ACMediaVideo").setColor("darkgoldenrod").setDebug(true);

  function AssetCoreVideo(detailJson){
    logger.debug("creating AssetCoreVideo from json:", detailJson);
    AssetCoreMedia.call(this, detailJson); // call super constructor.
  }

  // subclass extends superclass
  AssetCoreVideo.prototype = Object.create(AssetCoreMedia.prototype);
  AssetCoreVideo.prototype.constructor = AssetCoreMedia;

  // if quality is not set (e.g. null or undefined) it is tried to use jwPlayers defaultQuality if a quality is needed for this provider
  AssetCoreVideo.prototype._qualityDetails = function(qualityName){
    if (helper.undefOrNull(qualityName)){
      qualityName = this._languageDetails().defaultQuality;
      if (helper.undefOrNull(qualityName)){
        throw "Current Video cannot return qualities without defining a qualityName; AssetCore response did not contain a default qualityName!";
      }
    }

    var quality = helper.undefOrNull(this._languageDetails().qualities[qualityName]) ? this._languageDetails().qualities[this._languageDetails().defaultQuality] : this._languageDetails().qualities[qualityName];
    return quality.detail;
  };

  // if quality is not set (e.g. null or undefined) it is tried to use jwPlayers defaultQuality if a quality is needed for this provider
  AssetCoreVideo.prototype.width = function(qualityName){
    return this._qualityDetails(qualityName).width;
  };

  // if quality is not set (e.g. null or undefined) it is tried to use jwPlayers defaultQuality if a quality is needed for this provider
  AssetCoreVideo.prototype.height = function(qualityName){
    return this._qualityDetails(qualityName).height;
  };

  AssetCoreVideo.prototype.ratio = function(qualityName){
    var height = this.height(qualityName);
    var width = this.width(qualityName);
    return width / height;
  };

  AssetCoreVideo.prototype.qualities = function(){
    var keys = [];
    for(var k in this._languageDetails().qualities) keys.push(k);
    return keys;
  };

  AssetCoreVideo.prototype.qualityUrl = function(qualityName){
    var quality = this._qualityDetails(qualityName);
    if (!helper.undefOrNull(quality)){
      return quality.url;
    }
    return null;
  };

  AssetCoreVideo.prototype.useYoutube = function(){
    return this.provider() == "youtube";
  };

  AssetCoreVideo.prototype.useJwplayer = function(){
    return this.type() == "video" && this.provider() != "youtube";
  };

  AssetCoreVideo.prototype.isSmartMovie = function(){
    return this.type() == "smartmovie";
  };

  AssetCoreVideo.prototype.hasPreviewFrameUrl = function(qualityName){
    var url = this.previewFrameUrl(qualityName);
    return !helper.undefOrNull(url);
  };

  AssetCoreVideo.prototype.previewFrameUrl = function(qualityName){
    return this._qualityDetails(qualityName).previewFrameUrl;
  };

  AssetCoreVideo.prototype.reference = function(qualityName){
    if (!this.useYoutube()){
        throw "Only Youtube Videos have a reference! This video is of type '"+this.json.provider+"'!";
    } else {
      return this._qualityDetails(qualityName).reference;
    }
  };

  // if quality is not set (e.g. null or undefined) it is tried to use jwPlayers defaultQuality if a quality is needed for this provider
  AssetCoreVideo.prototype.url = function(qualityName){
    var langDet = this._languageDetails();
    if (!helper.undefOrNull(langDet.url)){
      return langDet.url;
    } else {
      return this._qualityDetails(qualityName).url;
    }
  };

  AssetCoreVideo.prototype.durationMs = function(){
    return this._defaultQuality().detail.durationMs;
  };

}());



//////////////////
// WEBPACK FOOTER
// ./src/AssetCore/mediaVideo.js
// module id = 9
// module chunks = 0